/** Number of matches shown when collapsed */
export const COLLAPSED_MATCHES_COUNT = 3;

/** Maximum matches to display even when expanded */
export const MAX_MATCHES_COUNT = 10;
